<template>
  <v-row justify="center">
    <v-dialog v-model="openModal" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Remarks</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Tanggal"
                  required
                  type="date"
                  v-model="formData.tgl"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Jam"
                  required
                  type="time"
                  v-model="formData.jam"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-combobox
                  label="Nama Pelapor"
                  :items="items.karyawan"
                  :loading="loading.karyawan"
                  :disabled="loading.karyawan"
                  v-model="formData.kode_karyawan"
                  hide-details
                >
                </v-combobox>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-combobox
                  label="Kategori"
                  :items="items.kategori"
                  :loading="loading.kategori"
                  :disabled="loading.kategori"
                  v-model="formData.kategori"
                  hide-details
                >
                </v-combobox>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Kode TTPB"
                  required
                  v-model="formData.ttpb"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="KC"
                  required
                  v-model="formData.kc"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="KV"
                  required
                  v-model="formData.kv"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="8">
                <v-text-field
                  label="Deskripsi Kejadian"
                  required
                  v-model="formData.deskripsi_kejadian"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Remarks Management"
                  required
                  v-model="formData.remarks_management"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            :disabled="loading.updateData"
            tabindex="-1"
            @click="
              $emit('close-modal');
              resetFormData();
            "
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            :loading="loading.updateData"
            text
            @click="updateData"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  name: "EditModal",
  props: ["openModal", "id"],
  data() {
    return {
      formData: {
        id: "",
        kode_karyawan: "",
        kategori: "",
        tgl: "",
        jam: "",
        ttpb: "",
        kc: "",
        kv: "",
        deskripsi_kejadian: "",
        remarks_management: ""
      },
      items: {
        karyawan: [],
        kategori: []
      },
      loading: {
        karyawan: false,
        kategori: false,
        updateData: false,
        fetchData: false
      }
    };
  },
  watch: {
    async openModal(val) {
      if (val) {
        await this.fetchKategori();
        await this.fetchKaryawan();
        await this.fetchData();
      }
    }
  },
  methods: {
    async fetchData() {
      this.loading.fetchData = true;

      await axios
        .get(`laporan-kejadian/${this.id}`)
        .then(res => {
          this.formData.kode_karyawan = {
            text: res.data.karyawan.nama,
            value: res.data.kode_karyawan
          };
          this.formData.kategori = res.data.kategori;
          this.formData.tgl = res.data.tgl;
          this.formData.jam = res.data.jam;
          this.formData.ttpb = res.data.ttpb;
          this.formData.kc = res.data.kc;
          this.formData.kv = res.data.kv;
          this.formData.deskripsi_kejadian = res.data.deskripsi_kejadian;
          this.formData.remarks_management = res.data.remarks_management;

          this.loading.fetchData = false;
        })
        .catch(err => {
          this.loading.fetchData = false;

          alert(err.response.data.message);
        });
    },
    async updateData() {
      this.loading.updateData = true;

      await axios
        .put(`laporan-kejadian/${this.id}`, this.formData)
        .then(res => {
          this.loading.updateData = false;
          this.$emit("close-modal");

          this.resetFormData();
        })
        .catch(err => {
          this.loading.updateData = false;

          alert(err.response.data.message);
        });
    },
    async fetchKaryawan() {
      this.loading.karyawan = true;

      await axios
        .get(`karyawan`)
        .then(res => {
          this.items.karyawan = res.data.map(item => ({
            text: item.nama,
            value: item.user_id
          }));

          this.loading.karyawan = false;
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    async fetchKategori() {
      this.loading.kategori = true;

      await axios
        .get(`kategori-laporan-kejadian`)
        .then(res => {
          this.loading.kategori = false;
          this.items.kategori = res.data;
        })
        .catch(err => {
          this.loading.kategori = false;

          alert(err.response.data.message);
        });
    },
    resetFormData() {
      this.formData.kode_karyawan = "";
      this.formData.kategori = "";
      this.formData.tgl = "";
      this.formData.jam = "";
      this.formData.ttpb = "";
      this.formData.kc = "";
      this.formData.kv = "";
      this.formData.deskripsi_kejadian = "";
      this.formData.remarks_management = "";
    }
  }
};
</script>
